import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { Component } from 'react';
import { format } from 'date-fns';
export default class Chart_vd_hr extends Component {
    constructor(props) {
        super(props);
        //this.chartRef = React.createRef();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.data !== this.props.data) {
            this.componentDidMount();
        }
    }
    componentDidMount() {
        //const myChartRef = this.chartRef.current.getContext("2d");
        var ctx = document.getElementById('Chart_vd_hr').getContext('2d');
        const data = this.props.data;
        const date = this.props.date;
        var x_data = [];
        var y_data = [];
        for (var i = 0; i < data.length; i++) {
            x_data.push(data[i]['mean']);
            var tmp = format(new Date(data[i]['time']), "yyyy/MM/dd");
            y_data.push(tmp);
        }
        var isstepped = false;
        if (window.Chart_vd_hr instanceof Chart) window.Chart_vd_hr.destroy();
        window.Chart_vd_hr = new Chart(ctx, {
            type: "line",
            // plugins: [ChartDataLabels],
            data: {
                //Bring in data
                labels: y_data,
                datasets: [
                    {
                        label: 'Average Heart Rate (bpm)',
                        data: x_data,
                        steppedLine: isstepped,
                        backgroundColor: 'rgba(252, 25, 25, 1)',
                        borderColor: 'rgba(252, 25, 25, 1)',
                        fill: false,
                        tension: '0',
                        datalabels: {
                            // anchor: 'end',
                            // align: 'top',

                            // formatter: Math.round,
                            // font: {
                            //     weight: 'bold'
                            // }
                            display: false
                        }
                    }
                ]
            },
            options: {
                //Customize chart options
                responsive: true,
                scales: {
                    xAxes: [{
                        type: 'time',
                        offset: true,
                        time: {
                            unit: 'day'
                        }
                    }],
                },
                title: {
                    display: true,
                    text: "Daily Average Heart Rate",
                    fontSize: 30,
                    fontFamily: 'Noto Sans CJK TC'
                }
            }
        });
    }
    render() {
        return (
            <div>
                <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.9.4/Chart.js"></script>
                <canvas id="Chart_vd_hr"></canvas>
            </div>
        );
    }
}